<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="../assets/logo-smaller.jpg" alt="Prostock" />
      </b-navbar-item>
    </template>

    <template slot="end">
      <b-navbar-item class="has-divider">
        <div class="is-user-name">
          <span>{{ this.$auth.user.name }}</span>
        </div>
      </b-navbar-item>
      <b-navbar-item>
        <router-link to="/jobSheets" exact-active-class="is-active">
          <b-icon icon="alpha-j-circle" custom-size="default" />
          <span>Job Sheets</span>
        </router-link>
      </b-navbar-item>
      <b-navbar-item class="has-dropdown is-hoverable">
        <a class="navbar-link is-arrowless">
          <b-icon icon="alpha-j-circle" custom-size="default" />
          <span>Loads</span>
        </a>
        <div class="navbar-dropdown">
          <router-link
            to="/addJob"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="alpha-a-circle" custom-size="default" />
            <span>Add Job</span>
          </router-link>
          <router-link
            to="/findLoad"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="alpha-f-circle" custom-size="default" />
            <span>Find Load</span>
          </router-link>
          <router-link
            to="/allocateLoad"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="alpha-a-circle" custom-size="default" />
            <span>Allocate Load</span>
          </router-link>
        </div>
      </b-navbar-item>

      <b-navbar-item class="has-dropdown is-hoverable">
        <a class="navbar-link is-arrowless">
          <b-icon icon="human-male-female" custom-size="default" />
          <span>Clients</span>
        </a>
        <div class="navbar-dropdown">
          <router-link
            to="/clients"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="human-male-female" custom-size="default" />
            <span>Manage Clients</span>
          </router-link>
          <router-link
            to="/address"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="home-city-outline" custom-size="default" />
            <span>New Address</span>
          </router-link>
        </div>
      </b-navbar-item>

      <b-navbar-item class="has-dropdown is-hoverable">
        <a class="navbar-link is-arrowless">
          <b-icon icon="alpha-a-circle" custom-size="default" />
          <span>Accounts</span>
        </a>
        <div class="navbar-dropdown">
          <router-link
            to="/invoice"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="subtitles" custom-size="default" />
            <span>Invoice</span>
          </router-link>
          <router-link
            to="/findInvoice"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="nfc-search-variant" custom-size="default" />
            <span>Find Invoice</span>
          </router-link>
        </div>
      </b-navbar-item>

      <b-navbar-item class="has-dropdown is-hoverable">
        <a class="navbar-link is-arrowless">
          <b-icon icon="menu" custom-size="default" />
          <span>Settings</span>
        </a>
        <div class="navbar-dropdown">
          <router-link
            to="/general"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="account" custom-size="default" />
            <span>General</span>
          </router-link>
          <router-link
            to="/users"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="account" custom-size="default" />
            <span>Users</span>
          </router-link>
          <router-link
            to="/vehicles"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="truck" custom-size="default" />
            <span>Vehicles</span>
          </router-link>
          <router-link
            to="/products"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="book" custom-size="default" />
            <span>Products</span>
          </router-link>
          <router-link
            to="/units"
            class="navbar-item"
            exact-active-class="is-active"
          >
            <b-icon icon="book" custom-size="default" />
            <span>Units</span>
          </router-link>
        </div>
      </b-navbar-item>

      <b-navbar-item @click="logout" title="Log out">
        <b-icon icon="logout" custom-size="default" />
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { mapState } from "vuex";
// import NavBarMenu from "@/components/NavBarMenu";

export default {
  name: "NavBar",
  components: {
    // NavBarMenu
  },
  data() {
    return {
      isMenuNavBarActive: false
    };
  },
  computed: {
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? "close" : "dots-vertical";
    },
    menuToggleMobileIcon() {
      return this.isAsideMobileExpanded ? "backburger" : "forwardburger";
    },
    menuToggleIcon() {
      return this.isAsideExpanded ? "backburger" : "forwardburger";
    },
    toggleTooltip() {
      return this.isAsideExpanded ? "Collapse" : "Expand";
    },
    ...mapState([
      "isNavBarVisible",
      "isAsideExpanded",
      "isAsideMobileExpanded",
      "isAsideRightVisible",
      "hasUpdates"
    ])
  },
  methods: {
    menuToggle() {
      this.$store.commit("asideStateToggle");
    },
    menuToggleMobile() {
      this.$store.commit("asideMobileStateToggle");
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive;
    },
    updatesToggle() {
      this.$store.commit("asideRightToggle");
    },
    addJob() {
      this.$store.commit("asideRightToggle");
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  },
  mounted() {
    this.$router.afterEach(() => {
      this.isMenuNavBarActive = false;
    });
  }
};
</script>
